/* unplugin-vue-components disabled */import { render } from "./UpdateSettingsSpe.vue?vue&type=template&id=28d18be4&scoped=true&ts=true"
import script from "./UpdateSettingsSpe.vue?vue&type=script&lang=ts"
export * from "./UpdateSettingsSpe.vue?vue&type=script&lang=ts"

import "./UpdateSettingsSpe.vue?vue&type=style&index=0&id=28d18be4&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28d18be4"]])

export default __exports__